import React, {FC, ReactNode} from 'react';

import {IconName} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {PaletteColorsEnum} from '../../../../../../libs/shared/ui/src/styles/paletteModel';
import {FrameCard, FrameCardProps} from './frameCard';
import {FrameCardCategory} from './frameCardCategory';
import {FrameCardName} from './frameCardName';
import {FrameCardPin, FrameCardPinProps} from './frameCardPin';
import {NativeFrameCardAvatar} from './nativeFrameCardAvatar';

/*
 * Props.
 */

interface NativeFrameCardProps extends FrameCardProps, FrameCardPinProps {
  name: ReactNode;
  category: ReactNode;
  iconName: IconName;
  color: PaletteColorsEnum | string;
}

/*
 * Component.
 */

export const NativeFrameCard: FC<NativeFrameCardProps> = (props) => (
  <FrameCard {...props} isEnabled>
    <NativeFrameCardAvatar iconName={props.iconName} color={props.color} />
    <FrameCardName>{props.name}</FrameCardName>
    <FrameCardCategory>{props.category}</FrameCardCategory>
    <FrameCardPin {...props} />
  </FrameCard>
);
